import { useState, useEffect } from 'react';
import { subscribeToast } from '%/toast';

const DURATION = 4000;

const icons = {
  success: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  error: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  info: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 16V12M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
};

const colors = {
  success: { bg: '#1a7a4a', accent: '#22a06b' },
  error:   { bg: '#c0392b', accent: '#e74c3c' },
  info:    { bg: '#1d5fa8', accent: '#2980b9' },
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToast(({ id, message, type }) => {
      setToasts(prev => [...prev, { id, message, type }]);
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, DURATION);
    });
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 28,
      right: 28,
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      maxWidth: 380,
      pointerEvents: 'none',
    }}>
      {toasts.map(t => {
        const c = colors[t.type] || colors.success;
        return (
          <div
            key={t.id}
            style={{
              background: c.bg,
              color: '#fff',
              padding: '13px 16px',
              borderRadius: 12,
              boxShadow: '0 6px 24px rgba(0,0,0,0.22)',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              pointerEvents: 'all',
              borderLeft: `4px solid ${c.accent}`,
            }}
          >
            <span style={{ flexShrink: 0, opacity: 0.9 }}>{icons[t.type]}</span>
            <span style={{ flex: 1, fontSize: 13.5, fontWeight: 500, lineHeight: 1.45 }}>{t.message}</span>
            <span
              onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
              style={{ cursor: 'pointer', opacity: 0.65, fontSize: 18, lineHeight: 1, flexShrink: 0, paddingLeft: 4 }}
            >✕</span>
          </div>
        );
      })}
    </div>
  );
};

export default ToastContainer;
